import {DatePipe} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ApplicationRef, NgModule} from '@angular/core';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PreloadAllModules, RouterModule} from '@angular/router';
import {createInputTransfer, createNewHosts, removeNgStyles} from '@angularclass/hmr';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
// import {AutoCompleteModule} from 'primeng/autocomplete';
import {TranslateModule} from '@ngx-translate/core';
import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';
// import {ChartModule} from 'angular2-highcharts';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import "froala-editor/js/froala_editor.pkgd.min.js";
import {Ng2AutoCompleteModule} from 'ng2-auto-complete';
//import { ToastModule, ToastOptions } from 'ng2-toastr';
import {ColorPickerModule} from 'ngx-color-picker';
import {QuillModule} from 'ngx-quill';
import {UiSwitchModule} from 'ngx-toggle-switch';
import {TreeviewModule} from 'ngx-treeview';
import {AutoCompleteModule} from 'primeng/autocomplete';
import '../styles/headings.css';
import '../styles/styles.scss';
import {AboutComponent} from './about';
import {AppComponent} from './app.component';
import {APP_RESOLVER_PROVIDERS} from './app.resolver';
import {ROUTES} from './app.routes';
import {AppState, InternalStateType} from './app.service';
// Bi module
import {BIAdminModule} from './bi';
import {CobComponent} from './cob/cob.component';
import {EmployeeImageUploadComponent} from './cob/imageUpload.component';
import {ConfirmationComponent} from './confirmation/confirmation';
import {ConfirmationModel} from './confirmation/confirmationModel';
import {ScrollTopDirective} from './directives/scroll-top-on-condition';
// import { EmployeeFilter } from './employee/employeeFilter';
import {AddEmployeesComponent} from './employee/addEmployees';
import {AddSupervisor} from './employee/addSupervisor';
import {ActionSuspend} from './employee/employeeActions/actionSuspend';
import {ResetPasswordPage} from './employee/employeeActions/resetPasswordByAdmin';
import {EmployeeFilterModule} from './employee/employeeFilter.module';
// employee
import {EmployeesListingPage} from './employee/employeeList';
import {EmployeeSearch} from './employee/employeeSearch';
import {EmployeeTransferComponent} from './employee/employeeTransfer/employeeTransfer';
import {environment} from './environment';
// import { Tabs} from './Tabs/Tabs';
import {Header} from './header/header';
import {ImageUploadModule} from './image-upload/image-upload.module';
import {CropImageComponent} from './imageCropper/imageCropper';
import {MenuComponent} from './menu/menu';
import {NoContentComponent} from './no-content';
import {Announcements} from './programManagement/announcements/announcements';
import {ScheduleAnnouncement} from './programManagement/announcements/scheduleAnnouncement';


import {AuthService} from './shared/auth/auth.service';
import {JwtInterceptor} from './shared/auth/jwt.interceptor';
import {PermissionHelper} from './shared/permissions/permissions';
import {Auth} from './shared/services/auth';
import {Configuration} from './shared/services/configuration';
import {DateTimeUtils} from './shared/services/date-utils';
import {HttpClientCustom} from './shared/services/http.client';
import {NumberUtils} from './shared/services/number.utils';
import {ThemeService} from './shared/services/theme-service';
import {SharedData} from './shared/sharedData';

import {CreateTenantComponent} from './superAdmin/createTenant';
import {TenantManagementComponent} from './superAdmin/tenantManagement';
import {UpdateTenantComponent} from './superAdmin/updateTenant';
import {SwitchUserComponent} from './switchUser/switchUser';
import {ToasterComponent} from './toasterComponent/toasterComponent';
import {AddDesignationComponent} from './tools/addDesignation';
import {AddOrgUnitTypeComponent} from './tools/organizationUnit/organizationUnit';
import {OrgUnitTypePageComponent} from './tools/organizationUnit/organizationUnitList';

import {AddEmployementTypeComponent} from './tools/addEmpType';
import {AddGradeComponent} from './tools/addGrade';
import {AddManagerLevelComponent} from './tools/addMgrLevel';
import {AddOrganizationComponent} from './tools/org/addOrganization';
import {AddParentOrganizationComponent} from './tools/org/addParentOrganization';
import {ChildOrgComponent} from './tools/org/childOrgs';
import {DesignationPageComponent} from './tools/designationList';

import {EmployementTypePageComponent} from './tools/empTypeList';
import {GradePageComponent} from './tools/gradeList';
import {ManagerLevelComponent} from './tools/mgrLevelList';
import {OrgComponent} from './tools/org/org';
import {OrganizationPage} from './tools/org/organizationList';
import {AddUsersToRolesComponent} from './tools/rolesAndPermission/addUsersToRole';
import {ChildOperationComponent} from './tools/rolesAndPermission/childOperations';
import {CreateRolesAndPermissionComponent} from './tools/rolesAndPermission/createRolesAndPermission';
import {EmployeeInRoleComponent} from './tools/rolesAndPermission/employeesInRole';
import {OperationComponent} from './tools/rolesAndPermission/operationComponent';
import {RolesAndPermissionComponent} from './tools/rolesAndPermission/rolesAndPermission';
import {TenantPreferenceComponent} from './tools/tenantPreference';
import {AddUserGroupComponent} from './tools/userGroup/addUserGroup';
import {AddUsersToGroupComponent} from './tools/userGroup/addUsersToGroup';
import {EmployeeInGroupComponent} from './tools/userGroup/employeesInGroup';
import {UserGroupPage} from './tools/userGroup/userGroup';
import {NotificationGridComponent} from './tools/notificationEditor/notificationGridComponent';
import {EditNotificationComponent} from './tools/notificationEditor/editNotificationComponent';

import {NotificationLangGridComponent} from './tools/notificationEditor/notificationLangGridComponent';
import {EditNotificationLangComponent} from './tools/notificationEditor/editNotificationLangComponent';
import {BuildDetailsComponent} from './superAdmin/buildDetailsComponent';
import {ClearCacheComponent} from './tools/clearComponent/clearComponent';
import {EmailNotification} from './programManagement/emailNotification/emailNotification';
import {EmailPreview} from './programManagement/emailNotification/emailPreview'
import {MobileAppManagementComponent} from './superAdmin/mobileAppManagement';
import {CreateMobileComponent} from './superAdmin/createMobileApplication';
import {DeleteMobileComponent} from './superAdmin/deleteMobileApplication';
import {PasswordPolicyComponent} from './tools/passwordPolicy/passwordPolicy';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {EmployeeStatus} from './employee/statusPipe';
import {DndModule} from 'ng2-dnd';
import {BulkResignComponent} from './bulkResign/bulkResign.component';
import {ManageOperationComponent} from './tools/operations/manageOperation.component';
import {AddOperationComponent} from './tools/operations/addOperation.component';
// import {HighchartsStatic} from "angular2-highcharts/dist/HighchartsService";
import {ImageCropperModule} from "ng2-img-cropper";
import {BulkUploadComponent} from "./bulkUpload/bulkUpload";
import {CommonAppModule} from "./common/common-app.module";
import { CopyClipboardDirective } from './directives/copy-to-clipboard-directive';


const APP_PROVIDERS = [
    ...APP_RESOLVER_PROVIDERS,
    AppState
];
type StoreType = {
    state: InternalStateType,
    restoreInputValues: () => void,
    disposeOldHosts: () => void
};


const dndModule = DndModule.forRoot();
const treeviewModule = TreeviewModule.forRoot();
const imageUploadModule = ImageUploadModule.forRoot();
const ngbModule = NgbModule.forRoot();
const froalaEditorModule = FroalaEditorModule.forRoot();
const froalaViewModule = FroalaViewModule.forRoot();
const routerModule = RouterModule.forRoot(ROUTES, {
    useHash: true,
    preloadingStrategy: PreloadAllModules
});

// export function highchartsFactory() {
//     const hc = require('highcharts');
//     return hc;
// }


@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        ScrollTopDirective,
        CopyClipboardDirective,
        AppComponent,
        // Employee related
        EmployeesListingPage,
        EmployeeTransferComponent,
        EmployeeSearch,
        AddEmployeesComponent,
        SwitchUserComponent,
        // Master data components
        DesignationPageComponent,
        OrgUnitTypePageComponent,
        EmployementTypePageComponent,
        GradePageComponent,
        AddDesignationComponent,
        AddOrgUnitTypeComponent,
        AddUserGroupComponent,
        AddUsersToGroupComponent,
        AddEmployementTypeComponent,
        AddGradeComponent,
        AddManagerLevelComponent,
        CropImageComponent,
        BulkUploadComponent,
        ToasterComponent,
        AddParentOrganizationComponent,
        NotificationGridComponent,
        EditNotificationComponent,
        NotificationLangGridComponent,
        EditNotificationLangComponent,
        // ProgramMenuPage,
        DesignationPageComponent,
        UserGroupPage,
        EmployementTypePageComponent,
        ManagerLevelComponent,
        RolesAndPermissionComponent,
        AddOperationComponent,
        ManageOperationComponent,
        CobComponent,
        EmployeeImageUploadComponent,
        CreateRolesAndPermissionComponent,
        AddUsersToRolesComponent,
        OperationComponent,
        ChildOperationComponent,
        EmployeeInRoleComponent,
        EmployeeInGroupComponent,
        ConfirmationComponent,
        ConfirmationModel,
        AboutComponent,
        NoContentComponent,
        Header,
        Announcements,
        ActionSuspend,
        ResetPasswordPage,
        AddSupervisor,
        //  EmployeeMenu,
        MenuComponent,
        TenantManagementComponent,
        BuildDetailsComponent,
        CreateTenantComponent,
        UpdateTenantComponent,
        OrganizationPage,
        OrgComponent,
        ChildOrgComponent,
        AddOrganizationComponent,
        ScheduleAnnouncement,
        TenantPreferenceComponent,
        ClearCacheComponent,
        EmailNotification,
        EmailPreview,
        MobileAppManagementComponent,
        CreateMobileComponent,
        DeleteMobileComponent,
        PasswordPolicyComponent,
        EmployeeStatus,
        BulkResignComponent
    ],

    entryComponents: [
        ConfirmationComponent,
        ConfirmationModel,
        EmployeeTransferComponent,
        CropImageComponent,
        ConfirmationComponent,
        ActionSuspend,
        ResetPasswordPage,
        AddSupervisor,
        ScheduleAnnouncement,
        AddParentOrganizationComponent,
        EmailPreview,
        AddOperationComponent,
        CreateMobileComponent,
        DeleteMobileComponent
    ],

    imports: [
        BrowserModule,
        dndModule,
        treeviewModule,
        imageUploadModule,
        ngbModule,
        routerModule,
        froalaEditorModule,
        froalaViewModule,
        // ChartModule, 
        BIAdminModule,
        ReactiveFormsModule,
        QuillModule,
        AngularMultiSelectModule,
        DragDropModule,
        AutoCompleteModule,
        UiSwitchModule,
        ColorPickerModule,
        BrowserAnimationsModule,
        Ng2AutoCompleteModule,
        FormsModule,
        CommonAppModule,
        EmployeeFilterModule,
        ImageCropperModule,
        environment.showDevModule ? [] : [],
    ],

    providers: [environment.ENV_PROVIDERS, APP_PROVIDERS, NgbActiveModal, HttpClientCustom,
        Auth,
        Configuration,
        AuthService,
        {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
        DateTimeUtils,
        NumberUtils,
        ThemeService,
        SharedData,
        FormBuilder,
        ToasterComponent,
        PermissionHelper,
        DatePipe,
        // {
        //     provide: HighchartsStatic,
        //     useFactory: highchartsFactory
        // }

        // { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
    ], exports: [TranslateModule]
})

export class AppModule {
    constructor(
        public appRef: ApplicationRef,
        public appState: AppState
    ) {
    }

    public hmrOnInit(store: StoreType) {
        if (!store || !store.state) {
            return;
        }
        console.log('HMR store', JSON.stringify(store, null, 2));
        this.appState._state = store.state;
        if ('restoreInputValues' in store) {
            let restoreInputValues = store.restoreInputValues;
            setTimeout(restoreInputValues);
        }

        this.appRef.tick();
        delete store.state;
        delete store.restoreInputValues;
    }

    public hmrOnDestroy(store: StoreType) {
        const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
        const state = this.appState._state;
        store.state = state;
        store.disposeOldHosts = createNewHosts(cmpLocation);
        store.restoreInputValues = createInputTransfer();
        removeNgStyles();
    }

    public hmrAfterDestroy(store: StoreType) {
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts